module.exports = "/_next/static/images/lidove-noviny-dd66b9948142f4a450b5ee20f4b1bfb4.svg";